import { render, staticRenderFns } from "./CommonButton.vue?vue&type=template&id=72fc3fa8"
import script from "./CommonButton.vue?vue&type=script&lang=ts"
export * from "./CommonButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports